import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';
import { useColorScheme } from '@mui/material';

// ----------------------------------------------------------------------

export function OurOperationalSolutions({ sx, ...other }) {
  const renderImage = () => (
    <Box
      component="img"
      alt="Services"
      src={`${CONFIG.assetsDir}/assets/images/home/ouroparation.webp`}
      sx={{ width: 480, borderRadius: 2 }}
    />
  );

  const renderTexts = () => (
    <>
      <Typography variant="h2" sx={{ fontSize: '2.5rem !important' }}>
        Our Operational Solutions
      </Typography>
      <Typography sx={{ my: 3, color: 'text.secondary' }}>
        We go beyond traditional freight by combining smart technology with reliable logistics. Our
        goal is simple: to move goods with precision, speed, and full transparency.
      </Typography>
    </>
  );

  const renderList = () => (
    <Box
      component="ul"
      sx={{
        mb: 5,
        gap: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {[
        <span>
          <strong>Smart logistics, not just trucks</strong>– powered by digital systems.
        </span>,
        <span>
          <strong>Customized fleets</strong> for any size, need, or frequency.
        </span>,
        <span>
          <strong>Nationwide coverage in Saudi Arabia</strong>, expanding to the GCC.
        </span>,
        <span>
          <strong>Seamless integration</strong> with client platforms.
        </span>,
        <span>
          <strong>Clear costs and timelines</strong>– disciplined logistics every time.
        </span>,
      ].map((text, index) => (
        <Box component="li" key={index} sx={{ gap: 1, display: 'flex', alignItems: 'center' }}>
          <Box
            component="span"
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: 'primary.main',
            }}
          />
          {text}
        </Box>
      ))}
    </Box>
  );
  const { mode } = useColorScheme();
  return (
    <Box
      component="section"
      sx={[
        {
          pt: { xs: 10, md: 15 },
          pb: { xs: 5, md: 10 },
          bgcolor: mode === 'light' ? 'white' : 'background.neutral',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Grid
          container
          spacing={{ xs: 5, md: 3 }}
          sx={{ alignItems: 'center', justifyContent: 'space-between' }}
        >
          <Grid size={{ xs: 12, md: 6, lg: 5 }}>{renderImage()}</Grid>

          <Grid size={{ xs: 12, md: 6, lg: 6 }}>
            {renderTexts()}
            {renderList()}

            {/* <Button
              component={RouterLink}
              href={paths.marketing.caseStudies}
              size="large"
              color="inherit"
              variant="outlined"
              endIcon={<Iconify icon="carbon:chevron-right" />}
            >
              Check our work
            </Button> */}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
